import { Link } from "react-router-dom";
import { MapPin, BadgeCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { assetUrl } from "@/lib/api";

export const PractitionerCard = ({ p }) => (
  <Link to={`/practitioner/${p.id}`} data-testid={`practitioner-card-${p.id}`}
    className="silk-card rounded-lg overflow-hidden block group">
    <div className="aspect-[4/3] overflow-hidden bg-secondary">
      {p.photo ? (
        <img src={assetUrl(p.photo)} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-muted-foreground font-display text-4xl">{p.name?.[0]}</div>
      )}
    </div>
    <div className="p-5">
      <div className="flex items-center gap-2 mb-1">
        <h3 className="font-display text-xl font-semibold text-foreground">{p.business_name}</h3>
        {p.verified && <BadgeCheck size={16} className="text-primary shrink-0" />}
      </div>
      <p className="text-sm text-muted-foreground mb-3">{p.name}</p>
      <div className="flex flex-wrap items-center gap-2">
        <Badge variant="secondary" className="font-normal">{p.subcategory_name || p.category_name}</Badge>
        <span className="text-xs text-muted-foreground flex items-center gap-1"><MapPin size={12} />{p.city_name}</span>
      </div>
      {p.services?.[0] && (
        <div className="mt-3 flex items-center justify-between">
          <p className="text-sm text-primary/90">From ${Math.min(...p.services.map((s) => s.price))} CAD</p>
          {p.rating_count > 0 && (
            <p className="text-xs text-muted-foreground" data-testid={`card-rating-${p.id}`}>
              <span className="text-primary font-medium">{p.rating_avg}</span>/3 · {p.rating_count} review{p.rating_count > 1 ? "s" : ""}
            </p>
          )}
        </div>
      )}
    </div>
  </Link>
);
